import { IncomingMessage } from 'http';

/***
 * Returns specified cookie value or undefined if not found
 */
export const getSSRCookie = (request: IncomingMessage | undefined, key: string): string => {
  if (!request) {
    throw Error('Request is not provided');
  }

  const cookies = cookiesToObject(request.headers.cookie || '');

  return cookies[key];
};

/**
 * Converts cookie string into object like Record<string, string>
 */
export const cookiesToObject = (cookieString: string): Record<string, string> => {
  if (!cookieString) {
    return {};
  }

  return cookieString.split(';').reduce((res, c) => {
    const [key, val] = c.trim().split('=').map(decodeURIComponent);

    try {
      return Object.assign(res, { [key]: JSON.parse(val) });
    } catch (e) {
      return Object.assign(res, { [key]: val });
    }
  }, {});
};
